import React from "react";
import { Icon } from "./UIElements/Icon";
import { cn } from "@/lib/utils";

const LocaleSelector = ({
  id,
  label,
  value,
  onChange,
  options,
  showLabel = true,
  showLeadingIcon = true,
  containerClassName = "",
  labelClassName = "",
  selectClassName = "",
}) => {
  return (
    <div
      className={cn(
        "inline-flex items-center",
        showLabel && "gap-2",
        containerClassName,
      )}
    >
      <label
        htmlFor={id}
        className={cn(
          showLabel
            ? "text-muted-foreground text-xs font-semibold tracking-wide"
            : "sr-only",
          labelClassName,
        )}
      >
        {label}
      </label>

      <div className="relative">
        {showLeadingIcon && (
          <Icon
            name="Languages"
            className="text-muted-foreground pointer-events-none absolute start-2.5 top-1/2 h-4 w-4 -translate-y-1/2"
          />
        )}
        <select
          id={id}
          value={value}
          onChange={onChange}
          aria-label={label}
          className={cn(
            "border-input bg-background text-foreground focus-visible:ring-ring h-9 min-w-[124px] cursor-pointer appearance-none rounded-[var(--od-radius-control)] border py-1 pe-8 text-[13px] font-medium shadow-none transition-colors outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--background)] motion-reduce:transition-none forced-colors:border-[FieldText]",
            showLeadingIcon ? "ps-8" : "ps-3",
            selectClassName,
          )}
        >
          {options.map((option) => (
            <option key={option.code} value={option.code}>
              {option.label}
            </option>
          ))}
        </select>
        <Icon
          name="ChevronDown"
          className="text-muted-foreground pointer-events-none absolute end-2 top-1/2 h-4 w-4 -translate-y-1/2"
        />
      </div>
    </div>
  );
};

export default LocaleSelector;
